import { AnyAction } from 'redux'
import { GET_BANNER, FETCHING } from '../constants/actionTypes'
import { GETBannerDataProps } from '../../interfaces/banners'

export interface BannerStateProps {
  fetching: boolean
  banners: GETBannerDataProps[]
}

const initialState: BannerStateProps = {
  fetching: false,
  banners: [],
}

const bannersReducer = (
  state = initialState,
  action: AnyAction
): BannerStateProps => {
  switch (action.type) {
    case FETCHING:
      return { ...state, fetching: action.payload }

    case GET_BANNER:
      return { ...state, banners: action.payload }

    default:
      return state
  }
}

export default bannersReducer
